// removed by extract-text-webpack-plugin
module.exports = {"attendance-scan-message-modal":"attendance-scan-message-modal","header":"header","close-button":"close-button","classtop-modal-content":"classtop-modal-content","attendance-scan-message-modal-content":"attendance-scan-message-modal-content","btn-container":"btn-container","input-container":"input-container"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/AttendanceScanMessage/Modal.scss
// module id = 8bO9
// module chunks = 0